import React from "react";
import {
  ShieldCheck,
  BrainCircuit,
  Users2,
  GraduationCap,
  MessageSquareQuote,
  Sparkles,
} from "lucide-react";

const SERVICES = [
  {
    icon: Users2,
    title: "Behavioural Training for Employees",
    body:
      "Custom, outcome-first workshops that shift workplace behaviours — communication, ownership, empathy and team dynamics.",
    tag: "Signature",
  },
  {
    icon: ShieldCheck,
    title: "Certified POSH Training",
    body:
      "Compliance-grade Prevention of Sexual Harassment sessions for organisations and IC members. Practical, sensitive, legally aligned.",
    tag: "Compliance",
  },
  {
    icon: BrainCircuit,
    title: "Neuro Linguistic Programming",
    body:
      "NLP-based coaching for mindset shifts, communication upgrades and reframing limiting patterns.",
    tag: "NLP",
  },
  {
    icon: GraduationCap,
    title: "Workshops for Educational Institutes",
    body:
      "Interactive sessions for students on communication, etiquette, self-awareness and career readiness.",
    tag: "Campus",
  },
  {
    icon: MessageSquareQuote,
    title: "Corporate Programs",
    body:
      "Multi-day virtual or in-person programs for leadership, managers and high-potential teams.",
    tag: "Enterprise",
  },
  {
    icon: Sparkles,
    title: "One-on-One Coaching",
    body:
      "Focused private coaching for professionals preparing for interviews, promotions or public speaking.",
    tag: "1:1",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="border-b border-black/10 bg-[color:var(--bts-surface)]"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="overline mb-3">Services</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-black leading-[0.98] max-w-2xl">
              A full spectrum of behavioural training.
            </h2>
          </div>
          <p className="max-w-md text-neutral-700 text-sm md:text-base">
            Whether it&apos;s compliance training, leadership programs or campus
            workshops, every engagement is designed around outcomes and evidence
            of change.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className={`svc-card p-7 md:p-8 flex flex-col gap-4 ${
                  i % 3 !== 2 ? "lg:border-r-0" : ""
                } ${i < SERVICES.length - 3 ? "lg:border-b-0" : ""} md:[&:nth-child(odd)]:border-r-0 md:[&:nth-child(-n+4)]:border-b-0 lg:[&]:border-r lg:[&]:border-b`}
                style={{ minHeight: 260 }}
              >
                <div className="flex items-start justify-between">
                  <Icon size={28} strokeWidth={1.6} />
                  <span className="text-[10px] tracking-[0.18em] uppercase font-bold text-neutral-500">
                    {s.tag}
                  </span>
                </div>
                <div>
                  <h3 className="font-display text-xl md:text-2xl text-black leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm md:text-[15px] text-neutral-700 leading-relaxed">
                    {s.body}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
